// 用户认证系统
// 模拟用户数据
const mockUsers = [
    {
        id: 1,
        username: "hikerlover",
        email: "hiker@example.com",
        password: "123456", // 实际应用中应该加密
        avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=hikerlover",
        name: "徒步爱好者",
        joinDate: "2023-06-15",
        level: "资深驴友",
        completedRoutes: 12
    },
    {
        id: 2,
        username: "mountaineer",
        email: "mountain@example.com",
        password: "password",
        avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=mountaineer",
        name: "登山达人",
        joinDate: "2023-03-20",
        level: "专业向导",
        completedRoutes: 28
    }
];

// 认证系统类
class AuthSystem {
    constructor() {
        this.currentUser = null;
        this.users = mockUsers;
        this.loadUserFromStorage();
    }

    // 从本地存储加载用户信息
    loadUserFromStorage() {
        const userData = localStorage.getItem('hikechina_user');
        if (userData) {
            this.currentUser = JSON.parse(userData);
            this.updateUIForLoggedInUser();
        }
    }

    // 保存用户信息到本地存储
    saveUserToStorage(user) {
        localStorage.setItem('hikechina_user', JSON.stringify(user));
    }

    // 登录
    login(email, password) {
        const user = this.users.find(u => u.email === email && u.password === password);
        if (user) {
            this.currentUser = user;
            this.saveUserToStorage(user);
            this.updateUIForLoggedInUser();
            this.closeAuthModal();
            this.showToast('登录成功！', 'success');
            return true;
        } else {
            this.showToast('邮箱或密码错误', 'error');
            return false;
        }
    }

    // 注册
    register(userData) {
        // 检查邮箱是否已存在
        if (this.users.find(u => u.email === userData.email)) {
            this.showToast('该邮箱已被注册', 'error');
            return false;
        }

        // 检查用户名是否已存在
        if (this.users.find(u => u.username === userData.username)) {
            this.showToast('该用户名已被使用', 'error');
            return false;
        }

        // 创建新用户
        const newUser = {
            id: this.users.length + 1,
            username: userData.username,
            email: userData.email,
            password: userData.password,
            avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${userData.username}`,
            name: userData.name || userData.username,
            joinDate: new Date().toISOString().split('T')[0],
            level: "新手驴友",
            completedRoutes: 0
        };

        this.users.push(newUser);
        this.currentUser = newUser;
        this.saveUserToStorage(newUser);
        this.updateUIForLoggedInUser();
        this.closeAuthModal();
        this.showToast('注册成功！欢迎加入徒步中国！', 'success');
        return true;
    }

    // 登出
    logout() {
        this.currentUser = null;
        localStorage.removeItem('hikechina_user');
        this.updateUIForLoggedOutUser();
        this.showToast('已退出登录', 'info');
    }

    // 检查是否已登录
    isLoggedIn() {
        return this.currentUser !== null;
    }

    // 获取当前用户
    getCurrentUser() {
        return this.currentUser;
    }

    // 更新UI - 已登录状态
    updateUIForLoggedInUser() {
        const authButtons = document.getElementById('auth-buttons');
        const userProfile = document.getElementById('user-profile');
        
        if (authButtons) authButtons.classList.add('hidden');
        if (userProfile) {
            userProfile.classList.remove('hidden');
            this.renderUserProfile();
        }
    }

    // 更新UI - 未登录状态
    updateUIForLoggedOutUser() {
        const authButtons = document.getElementById('auth-buttons');
        const userProfile = document.getElementById('user-profile');
        
        if (authButtons) authButtons.classList.remove('hidden');
        if (userProfile) userProfile.classList.add('hidden');
    }

    // 渲染用户资料
    renderUserProfile() {
        const userProfile = document.getElementById('user-profile');
        if (!userProfile || !this.currentUser) return;

        userProfile.innerHTML = `
            <div class="flex items-center space-x-3">
                <img src="${this.currentUser.avatar}" alt="${this.currentUser.name}" class="w-8 h-8 rounded-full">
                <div class="hidden md:block">
                    <div class="text-sm font-medium text-neutral-700">${this.currentUser.name}</div>
                    <div class="text-xs text-neutral-500">${this.currentUser.level}</div>
                </div>
                <div class="relative">
                    <button class="p-1 text-neutral-500 hover:text-neutral-700" id="user-menu-btn">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                        </svg>
                    </button>
                    <div class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-neutral-200 hidden" id="user-menu">
                        <div class="p-3 border-b border-neutral-200">
                            <div class="font-medium text-neutral-900">${this.currentUser.name}</div>
                            <div class="text-sm text-neutral-500">${this.currentUser.email}</div>
                        </div>
                        <div class="py-1">
                            <button class="w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" onclick="authSystem.showProfile()">
                                个人资料
                            </button>
                            <button class="w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" onclick="authSystem.showMyRoutes()">
                                我的路线
                            </button>
                            <button class="w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" onclick="authSystem.showSettings()">
                                设置
                            </button>
                            <div class="border-t border-neutral-200"></div>
                            <button class="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50" onclick="authSystem.logout()">
                                退出登录
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // 添加用户菜单事件监听
        this.attachUserMenuEvents();
    }

    // 添加用户菜单事件监听
    attachUserMenuEvents() {
        const userMenuBtn = document.getElementById('user-menu-btn');
        const userMenu = document.getElementById('user-menu');

        if (userMenuBtn && userMenu) {
            userMenuBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                userMenu.classList.toggle('hidden');
            });

            // 点击外部关闭菜单
            document.addEventListener('click', () => {
                userMenu.classList.add('hidden');
            });
        }
    }

    // 显示认证模态框
    showAuthModal(mode = 'login') {
        this.createAuthModal(mode);
    }

    // 创建认证模态框
    createAuthModal(mode) {
        // 移除现有模态框
        const existingModal = document.getElementById('auth-modal');
        if (existingModal) {
            existingModal.remove();
        }

        const modal = document.createElement('div');
        modal.id = 'auth-modal';
        modal.className = 'fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50';
        modal.innerHTML = `
            <div class="bg-white rounded-2xl max-w-md w-full p-6 relative">
                <button class="absolute top-4 right-4 text-neutral-400 hover:text-neutral-600" onclick="authSystem.closeAuthModal()">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
                
                <div class="text-center mb-6">
                    <div class="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg class="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                        </svg>
                    </div>
                    <h2 class="text-2xl font-bold text-neutral-900" id="auth-title">
                        ${mode === 'login' ? '登录' : '注册'}
                    </h2>
                    <p class="text-neutral-600 mt-2" id="auth-subtitle">
                        ${mode === 'login' ? '欢迎回到徒步中国' : '加入徒步中国社区'}
                    </p>
                </div>

                <form id="auth-form" class="space-y-4">
                    ${mode === 'register' ? `
                        <div>
                            <label class="block text-sm font-medium text-neutral-700 mb-2">姓名</label>
                            <input type="text" name="name" required class="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent" placeholder="请输入您的姓名">
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-neutral-700 mb-2">用户名</label>
                            <input type="text" name="username" required class="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent" placeholder="请输入用户名">
                        </div>
                    ` : ''}
                    
                    <div>
                        <label class="block text-sm font-medium text-neutral-700 mb-2">邮箱</label>
                        <input type="email" name="email" required class="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent" placeholder="请输入邮箱地址">
                    </div>
                    
                    <div>
                        <label class="block text-sm font-medium text-neutral-700 mb-2">密码</label>
                        <input type="password" name="password" required class="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent" placeholder="请输入密码">
                    </div>

                    ${mode === 'register' ? `
                        <div>
                            <label class="block text-sm font-medium text-neutral-700 mb-2">确认密码</label>
                            <input type="password" name="confirmPassword" required class="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent" placeholder="请再次输入密码">
                        </div>
                    ` : ''}

                    <button type="submit" class="w-full bg-primary-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-primary-700 transition-colors">
                        ${mode === 'login' ? '登录' : '注册'}
                    </button>
                </form>

                <div class="mt-6 text-center">
                    <p class="text-neutral-600">
                        ${mode === 'login' ? '还没有账号？' : '已有账号？'}
                        <button class="text-primary-600 hover:text-primary-700 font-medium" onclick="authSystem.switchAuthMode('${mode === 'login' ? 'register' : 'login'}')">
                            ${mode === 'login' ? '立即注册' : '立即登录'}
                        </button>
                    </p>
                </div>

                ${mode === 'login' ? `
                    <div class="mt-4 text-center">
                        <p class="text-sm text-neutral-500">演示账号：hiker@example.com / 123456</p>
                    </div>
                ` : ''}
            </div>
        `;

        document.body.appendChild(modal);
        document.body.style.overflow = 'hidden';

        // 添加表单提交事件
        this.attachAuthFormEvents(mode);
    }

    // 添加认证表单事件
    attachAuthFormEvents(mode) {
        const form = document.getElementById('auth-form');
        if (form) {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                const formData = new FormData(form);
                const data = Object.fromEntries(formData);

                if (mode === 'login') {
                    this.login(data.email, data.password);
                } else {
                    // 注册验证
                    if (data.password !== data.confirmPassword) {
                        this.showToast('两次输入的密码不一致', 'error');
                        return;
                    }
                    if (data.password.length < 6) {
                        this.showToast('密码长度至少6位', 'error');
                        return;
                    }
                    this.register(data);
                }
            });
        }
    }

    // 切换认证模式
    switchAuthMode(mode) {
        this.createAuthModal(mode);
    }

    // 关闭认证模态框
    closeAuthModal() {
        const modal = document.getElementById('auth-modal');
        if (modal) {
            modal.remove();
            document.body.style.overflow = '';
        }
    }

    // 显示个人资料
    showProfile() {
        if (!this.currentUser) return;
        
        alert(`个人资料功能开发中...\n\n当前用户：${this.currentUser.name}\n等级：${this.currentUser.level}\n完成路线：${this.currentUser.completedRoutes}条`);
    }

    // 显示我的路线
    showMyRoutes() {
        alert('我的路线功能开发中...');
    }

    // 显示设置
    showSettings() {
        alert('设置功能开发中...');
    }

    // 显示提示消息
    showToast(message, type = 'info') {
        const toast = document.createElement('div');
        toast.className = `fixed top-4 right-4 z-50 px-6 py-3 rounded-lg shadow-lg text-white transition-all duration-300 transform translate-x-full ${
            type === 'success' ? 'bg-green-500' :
            type === 'error' ? 'bg-red-500' :
            'bg-blue-500'
        }`;
        toast.textContent = message;
        
        document.body.appendChild(toast);
        
        // 显示动画
        setTimeout(() => {
            toast.classList.remove('translate-x-full');
        }, 100);
        
        // 自动隐藏
        setTimeout(() => {
            toast.classList.add('translate-x-full');
            setTimeout(() => {
                toast.remove();
            }, 300);
        }, 3000);
    }
}

// 创建全局认证系统实例
const authSystem = new AuthSystem();

// 导出认证系统，并挂载到 window 对象以供内联脚本使用
if (typeof window !== 'undefined') {
    window.authSystem = authSystem;
}

export { AuthSystem, authSystem };